import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppButton.css";

export default function WhatsAppButton(props) {
  return (
    <div
      id="whats-app-floating-btn"
      style={{ background: props.whatsAppColor }}
    >
      <a
        href={`https://wa.me/${props.whatsAppNumber}`}
        rel="noopener noreferrer"
        className="whats-app-btn-link"
        target="_blank"
        aria-label="Entre em contato via WhatsApp"
        style={{ color: props.white }}
      >
        <FaWhatsapp className="whats-app-btn-icon" />
      </a>
    </div>
  );
}
